import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

/**
 * @param {{
 *   label: string,
 *   value: string | number,
 *   trend?: 'up' | 'down' | null,
 *   trendLabel?: string,
 *   linkTo?: string,
 * }} props
 */
import ContentCard from "./ContentCard";
export default function StatCard({ label, value, trend, trendLabel, linkTo }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (linkTo) navigate(linkTo);
  };

  return (
    <ContentCard
      onClick={handleClick}
      sx={{ px: 3,
        py: '20px',
        cursor: linkTo ? 'pointer' : 'default',
        flex: 1,
        minWidth: 160,
        '&:hover': linkTo ?
        { borderColor: '#009688', boxShadow: '0 0 0 1px #009688' } :
        undefined,
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease'
      }}>
      
      <Typography sx={{ fontSize: '0.8125rem', color: 'var(--grey-500)', mb: '6px' }}>
        {label}
      </Typography>

      <Typography
        sx={{ fontSize: '1.75rem', fontWeight: 700, color: 'var(--grey-900)', lineHeight: 1.2 }}>
        
        {value}
      </Typography>

      {(trend || trendLabel) &&
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', mt: '8px' }}>
          {trend === 'up' && <TrendingUpIcon sx={{ fontSize: 16, color: '#2E7D32' }} />}
          {trend === 'down' && <TrendingDownIcon sx={{ fontSize: 16, color: '#B71C1C' }} />}
          {trendLabel &&
        <Typography
          sx={{ fontSize: '0.75rem',
            color: trend === 'up' ? '#2E7D32' : trend === 'down' ? '#B71C1C' : 'var(--grey-500)'
          }}>
          
              {trendLabel}
            </Typography>
        }
        </Box>
      }
    </ContentCard>);

}